/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ContentLoader from 'react-content-loader';

import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import styled from 'styled-components';

import Dropzone from './Dropzone';
import DrawerEditCommand from './editCommand/DrawerEditCommand';
import BindingDialog from './bindingDialog/BindingDialog';
import WarningDialog from './warningDialog/WarningDialog';

import { deleteCommand, createBatch, resetImportCommands } from './actions';
import { Title } from '../style';

import { displayInAppError } from '../../utils/toast/Toast';
import CreateBatchSuccess from './CreateBatchSuccess';

const getColor = props => {
  if (props.errorsbody || props.errorsitem) {
    return '#e53935';
  }
  if (props.warnings) {
    return '#ffa000';
  }
  return '#03a9f4';
};

const StyledChipContainer = styled(Paper)`
  padding-top: 22px;
  min-height: 200px;
  margin-bottom: 10px;
  background-color: #fff;
  outline: none;
  cursor: pointer;
`;

const StyledChip = styled(Chip)`
  color: ${props => getColor(props)};
  border-color: ${props => getColor(props)};
  margin: 10px;
  cursor: pointer;
`;

const ElementLoaderContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const ElementLoader = styled.div`
  width: 112px;
  height: 32px;
  margin: 10px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ImportCommands = ({
  commands,
  dispatchDeleteCommand,
  openDialogBindingOffer,
  dispatchCreateBatch,
  loadingImport,
  dispatchResetImportCommands,
  productIsInStock,
  history,
  createBatchSuccess
}) => {
  const [state, setState] = useState({
    openDialogCommand: false,
    openDialogWarning: false,
    commandIndex: 0
  });

  useEffect(
    () => () => {
      dispatchResetImportCommands();
    },
    [dispatchResetImportCommands]
  );

  const getCommandsForCreateBatch = () =>
    commands.map(command => ({
      ...command,
      readyToBePickedUp: productIsInStock ? true : null,
      customsDeclarations: command.customsDeclarations.map(
        (customsDeclaration, index) => ({
          ...customsDeclaration,
          quantity: command.items[index].quantity
        })
      )
    }));

  const handleOpenWarningDialog = () => {
    setState({ ...state, openDialogWarning: true });
  };

  const handleClickOpen = index => {
    setState({ ...state, openDialogCommand: true, commandIndex: index });
  };

  const handleCloseWarningDialog = () => {
    setState({ ...state, openDialogWarning: false });
  };

  const handleClose = () => {
    setState({ ...state, openDialogCommand: false });
  };

  const importCommands = () => {
    let containError = false;
    let containWarning = false;
    commands.forEach(command => {
      if (command.errorsItem.length) {
        containError = true;
      }
      if (command.warnings.length) {
        containWarning = true;
      }
    });
    if (containError) {
      displayInAppError(
        "Veuillez corriger les erreurs avant d'importer vos commandes"
      );
    } else if (containWarning) {
      handleOpenWarningDialog();
    } else {
      dispatchCreateBatch({ commands: getCommandsForCreateBatch() });
    }
  };

  return (
    <div>
      <Header>
        <Title>Import de commandes</Title>
        {!createBatchSuccess ? (
          <Button
            variant="contained"
            color="primary"
            onClick={() => history.push('/not-sent')}
          >
            <KeyboardArrowLeft style={{ marginRight: 5 }} />
            Retour colis prêt
          </Button>
        ) : null}
      </Header>
      {createBatchSuccess ? (
        <CreateBatchSuccess />
      ) : (
        <>
          <div hidden={commands.length}>
            <Dropzone />
          </div>
          {openDialogBindingOffer ? <BindingDialog /> : null}
          <DrawerEditCommand
            commandIndex={state.commandIndex}
            open={state.openDialogCommand}
            handleClose={handleClose}
          />
          <StyledChipContainer hidden={!commands.length}>
            {!loadingImport ? (
              <div>
                {commands.map((command, index) => (
                  <StyledChip
                    key={index}
                    label={command.externalReference}
                    variant="outlined"
                    warnings={command.warnings.length}
                    errorsitem={command.errorsItem.length}
                    onClick={() => handleClickOpen(index)}
                    onDelete={() => dispatchDeleteCommand(index)}
                  />
                ))}
              </div>
            ) : (
              <ElementLoaderContainer>
                {commands.map((command, index) => (
                  <ElementLoader key={index}>
                    <ContentLoader
                      height={35}
                      width={118}
                      speed={2}
                      backgroundColor="#f3f3f3"
                      foregroundColor="#ecebeb"
                    >
                      <rect x="7" y="4" rx="4" ry="4" width="104" height="29" />
                    </ContentLoader>
                  </ElementLoader>
                ))}
              </ElementLoaderContainer>
            )}
          </StyledChipContainer>
        </>
      )}
      <span hidden={!commands.length || createBatchSuccess}>
        Nombre de commandes : {commands.length}
      </span>
      <WarningDialog
        isOpen={state.openDialogWarning}
        handleClose={handleCloseWarningDialog}
        createBatch={() =>
          dispatchCreateBatch({ commands: getCommandsForCreateBatch() })
        }
      />
      <div
        style={{ textAlign: 'center', marginTop: 30 }}
        hidden={!commands.length || createBatchSuccess}
      >
        <Button
          style={{ marginRight: 10 }}
          variant="contained"
          color="secondary"
          onClick={() => dispatchResetImportCommands()}
        >
          Réinitialiser
        </Button>
        <Button
          style={{ marginLeft: 10 }}
          variant="contained"
          color="primary"
          onClick={importCommands}
        >
          Importer
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  commands: state.importCommands.commands,
  commandsIds: state.importCommands.commandsIds,
  openCoursierDialog: state.importCommands.openCoursierDialog,
  openDialogBindingOffer: state.importCommands.openDialogBindingOffer,
  loadingImport: state.importCommands.loadingImport,
  productIsInStock: state.importCommands.productIsInStock,
  createBatchSuccess: state.importCommands.createBatchSuccess
});

const mapDispatchToProps = dispatch => ({
  dispatchDeleteCommand: index => dispatch(deleteCommand(index)),
  dispatchCreateBatch: commands => dispatch(createBatch(commands)),
  dispatchResetImportCommands: () => dispatch(resetImportCommands())
});

ImportCommands.propTypes = {
  commands: PropTypes.array.isRequired,
  dispatchDeleteCommand: PropTypes.func.isRequired,
  dispatchResetImportCommands: PropTypes.func.isRequired,
  dispatchCreateBatch: PropTypes.func.isRequired,
  openDialogBindingOffer: PropTypes.bool.isRequired,
  loadingImport: PropTypes.bool.isRequired,
  productIsInStock: PropTypes.bool.isRequired,
  createBatchSuccess: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ImportCommands));
